import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
    name: 'customDateTime',
    standalone: true
})
export class CustomDateTimePipe implements PipeTransform {
    transform(val: string, format: string = 'DD/MM/YYYY hh:mm A'): string {
        if (!val) return '';

        let value = this.convertUtcToLocal(val);
        
        if (value === 'Invalid Date') {
            return value;
        }
        
        return moment(value).format(format);
    }

    convertUtcToLocal(utcDateString: string): string {
        // Parse UTC time correctly
        const momentDate = moment.utc(utcDateString);

        if (!momentDate.isValid()) {
            console.error("Invalid Date Detected!");
            return 'Invalid Date';
        }

        // Convert to the local timezone of the user's system
        return momentDate.local().format('YYYY/MM/DD hh:mm A');
    }
}
